import { ApplicationRef } from '@angular/core';
import { environment } from './environments/environment';
import { readLoginHint, removeLoginHintFromBrowserUrl } from './region/login-hint';
import { showBootError } from './region/region-picker';
import { ShellRegion } from './region/region-resolver';
import { startRegion } from './region/start-region';
import { reloadOnStaleChunkError } from './stale-chunk-reload';

// Read before the picker or the router can rewrite the URL; forwarded to the region login page.
const loginHint: string | null = readLoginHint(window.location.search);
removeLoginHintFromBrowserUrl();

// The region is resolved before Angular boots: every API URL derives from it.
startRegion(environment)
  .then((region: ShellRegion): Promise<ApplicationRef> =>
    import('./bootstrap').then((m: typeof import('./bootstrap')): Promise<ApplicationRef> =>
      m.bootstrap(region, loginHint)
    )
  )
  .catch((err: unknown): void => {
    if (!reloadOnStaleChunkError(err)) {
      console.error(err);
      showBootError(err);
    }
  });
